import { Schema } from "rsuite";

const { Model, Types } = Schema;

export type ResetPasswordFormType = {
  accountId?: string;
  NewPassword?: string;
  ConfirmNewPassword?: string;
  Token?: string;
};

export const ResetPasswordFormSchema = Model({
  accountId: Types.StringType(),
  NewPassword: Types.StringType().isRequired("New Password is required"),
  ConfirmNewPassword: Types.StringType().isRequired(
    "Confirm Password is required"
  ),
  Token: Types.StringType(),
});

export const ResetPasswordDefaultValues: ResetPasswordFormType = {
  accountId: "",
  NewPassword: "",
  ConfirmNewPassword: "",
  Token: "",
};
